import { render, staticRenderFns } from "./groupPayed.vue?vue&type=template&id=115b877a&scoped=true&"
import script from "./groupPayed.vue?vue&type=script&lang=js&"
export * from "./groupPayed.vue?vue&type=script&lang=js&"
import style0 from "./groupPayed.vue?vue&type=style&index=0&id=115b877a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115b877a",
  null
  
)

export default component.exports